var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vertical",staticStyle:{"height":"120px","width":"80vw"}},[_c('div',{staticStyle:{"width":"100%","height":"100%","margin-right":"10px","align-self":"center"},attrs:{"id":'scichart-root-' + _vm.sid}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b8ae9dd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Charts/SciChartOneLineAlarms.vue
// module id = 1637
// module chunks = 3 5 6 9 10